// extracted by mini-css-extract-plugin
export default {"userGreeting":"Home_userGreeting__vbxqC","greetingName":"Home_greetingName__9W6yX","greetingMessage":"Home_greetingMessage__sPOpQ"};